import Avatar from "./avatar";
import Group from "./group";

Avatar.Group = Group;
export default Avatar;
